import React, { useEffect } from 'react';
import { useLazyGetPageQuery } from '../../../redux/actions/Customer/FooterCustomer';
import { LegalPageLayout } from '../../../components/customer/LegalPageLayout';

export const TermsAndConditionsScreen: React.FC = () => {
    const [triggerGetPage, { data: response, isLoading, isError }] = useLazyGetPageQuery();

    useEffect(() => {
        triggerGetPage(3); // WebsitePageType.TermsAndConditions = 3
    }, [triggerGetPage]);

    return (
        <LegalPageLayout
            title="Terms & Conditions"
            subtitle="Read the rules and guidelines for using our services."
            isLoading={isLoading}
            isError={isError}
            contentData={response?.value?.data || null}
        />
    );
};
export default TermsAndConditionsScreen;